<template>
    <div>
        <loading v-if="loading" :size="2" message="Обновляем профиль..."></loading>
        <form v-else class="form-horizontal" @submit.prevent="beforeSubmit">
            <div class="form-group row" :class="{ 'has-danger': $v.newUserData.firstname.$error }">
                <label for="user-firstname" class="col-4 col-md-2 col-form-label">Имя</label>
                <div class="col-8 col-md-4">
                    <input v-if="currentUser.isAdmin" class="form-control" name="firstname" type="text" id="user-firstname" v-model="newUserData.firstname" @input="$v.newUserData.firstname.$touch()">
                    <input v-else class="form-control disabled" disabled name="firstname" type="text" id="user-firstname" v-model="newUserData.firstname">
                    <span class="small help-block text-danger" v-if="$v.newUserData.firstname.$error">Имя обязательно должно быть указано</span>
                </div>
                <div class="help-inline col-12 col-md-6" v-if="!currentUser.isAdmin">
                    <small class="text-muted">Имя может изменить только администратор</small>
                </div>
            </div>
            <div class="form-group row" :class="{ 'has-danger': $v.newUserData.lastname.$error }">
                <label for="user-lastname" class="col-4 col-md-2 col-form-label">Фамилия</label>
                <div class="col-8 col-md-4">
                    <input v-if="currentUser.isAdmin" class="form-control" type="text" id="user-lastname" v-model="newUserData.lastname" @input="$v.newUserData.lastname.$touch()">
                    <input v-else class="form-control disabled" disabled type="text" id="user-lastname" v-model="newUserData.lastname">
                    <span class="small help-block text-danger" v-if="$v.newUserData.lastname.$error">Фамилия обязательно должна быть указана</span>
                </div>
                <div class="help-inline col-12 col-md-6" v-if="!currentUser.isAdmin">
                    <small class="text-muted">Фамилию может изменить только администратор</small>
                </div>
            </div>
            <div class="form-group row" :class="{ 'has-danger': $v.newUserData.email.$error }">
                <label for="user-email" class="col-4 col-md-2 col-form-label">Электронная почта</label>
                <div class="col-8 col-md-4">
                    <input class="form-control" type="text" id="user-email" v-model="newUserData.email" @input="$v.newUserData.email.$touch()">
                    <span class="small help-block text-danger" v-if="$v.newUserData.email.$error">Адрес электронной почты обязателен и должен быть валидным</span>
                </div>
                <div class="help-inline col-12 col-md-6">
                    <small class="text-muted">На данный адрес будут приходить оповещения, также этот адрес используется для авторизации в Аларм Плане</small>
                </div>
            </div>
            <div class="form-group row" :class="{ 'has-danger': $v.newUserData.phone.$error }">
                <label for="user-phone" class="col-4 col-sm-2 col-form-label">Номер телефона</label>
                <div class="col-8 col-sm-4">
                    <div class="input-group">
                        <span class="input-group-addon">+7</span>
                        <input class="form-control" type="text" id="user-phone" v-model="newUserData.phone" @input="$v.newUserData.phone.$touch()">
                    </div>
                    <span class="small help-block text-danger" v-if="$v.newUserData.phone.$error">Телефон обязателен и должен состоять из 10 цифр</span>
                </div>
                <div class="help-inline col-12 col-md-6">
                    <small class="text-muted">На данный номер будут приходить оповещения. Настроить оповещения можно в следующей вкладке</small>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-4 col-md-2 col-form-label">Дата рождения</label>
                <div class="col-8 col-md-4">
                    <datepicker
                            v-model="newUserData.birthday"
                            format="dd/MM/yyyy">
                    </datepicker>
                </div>
                <div class="help-inline col-12 col-6">
                    <small class="text-muted">Мы поздравим Вас, когда прийдёт время</small>
                </div>
            </div>
            <div class="form-group row">
                <label for="user-skype" class="col-4 col-md-2 col-form-label">Skype</label>
                <div class="col-8 col-md-4">
                    <input class="form-control" type="text" id="user-skype" v-model="newUserData.skype">
                </div>
            </div>
            <div class="form-group row">
                <label for="user-icq" class="col-4 col-md-2 col-form-label">Id пользователя в Телеграм</label>
                <div class="col-8 col-md-4">
                    <input class="form-control" type="text" id="user-telegram" v-model="newUserData.telegramUserId">
                </div>
                <div class="help-inline col-12 col-md-6">
                    <small class="text-muted">Для того, чтобы получать уведомления в Телеграм необходимо указать id пользователя. Для этого подключитьсеь к боту <a href="https://t.me/AlarmPlanBot?start " target="_blank">@AlarmPlanBot</a>, нажав <b>Start</b>, в ответ бот пришлет вам id, который необходимо тут указать</small>
                </div>
            </div>
            <div class="form-group row" v-if="currentUser.isAdmin">
                <label for="user-icq" class="col-4 col-md-2 col-form-label">Id пользователя в AmoCrm</label>
                <div class="col-8 col-md-4">
                    <input class="form-control"
                           type="text"
                           id="user-amo-id"
                           v-model="newUserData.amoId"
                           :class="{ 'disabled': !currentUser.isAdmin }"
                           :disabled="!currentUser.isAdmin"
                    >
                </div>
            </div>
            <div class="form-group row">
                <div class="offset-sm-2 col-sm-10">
                    <button  :class="{ 'disabled': $v.newUserData.$invalid }" :disabled="$v.newUserData.$invalid"  type="submit" class="btn btn-primary">Сохранить</button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import { ADD_TOAST_MESSAGE } from 'vuex-toast'
  import { required, minLength, email, numeric, maxLength } from 'vuelidate/lib/validators'
  export default {
    computed: mapState({
      user: state => state.userStore.user,
      currentUser: state => state.globalStore.user
    }),
    data () {
      return {
        newUserData: {},
        loading: false
      }
    },
    methods: {
      /**
       * Валидация
       */
      beforeSubmit () {
        this.$v.newUserData.$touch()
        if (!this.$v.newUserData.$error) {
          this.updateProfile()
        }
      },
      /**
       * Обновление профиля пользователя
       */
      updateProfile () {
        this.loading = true
        this.$store.dispatch('updateUserProfile', this.newUserData).then((newUserData) => {
          if (this.currentUser.id === this.user.id) {
            this.$store.commit('UPDATE_USER', newUserData)
          }
          this.loading = false
          this.addToast({
            text: 'Профиль успешно обновлен',
            type: 'success',
            dismissAfter: 3000
          })
        }).catch((error) => {
          this.loading = false
          this.addToast({
            text: 'Произошла ошибка при обновлении профиля: ' + error,
            type: 'danger',
            dismissAfter: 3000
          })
        })
      },
      ...mapActions({
        addToast: ADD_TOAST_MESSAGE
      })
    },
    created () {
      this.newUserData = Object.assign({}, this.user)
    },
    components: {
//      datepicker
    },
    validations: {
      newUserData: {
        lastname: {
          required,
          minLength: minLength(2)
        },
        firstname: {
          required,
          minLength: minLength(2)
        },
        email: {
          required,
          email
        },
        phone: {
          required,
          numeric,
          maxLength: maxLength(10),
          minLength: minLength(10)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ProfileSettings.vue?7fc95d5c